export default class User {
  constructor () {
    this.username = null
    this.role = null
  }

  static fromJson (json) {
    let user = new this()
    if (json.username !== null) {
      user.username = json.username
    }
    if (json.role !== null) {
      user.role = json.role
    }
    return user
  }

  hasRole (roles) {
    return roles.indexOf(this.role) > -1
  }
}



// WEBPACK FOOTER //
// ./src/models/user.js